import {getTranslation} from "./get-translation";

const shouldLog = getTranslation("config_log_in_production") === "true";

export const logger = {
    log: (...message) => {
        if(process.env.NODE_ENV === "development" || shouldLog){
            window.originalLog(...message)
        }
    }
};